import type { FunctionComponent } from 'react';

import type { IconType } from '../../../icons/constants';
import Icon from '../../../icons/icon';

import styles from './option_icon_component.module.css';

interface OptionInterface {
  label?: string;
  value?: string;
  icon?: IconType | null;
  reserveIconSpace?: boolean;
}

interface OptionProps {
  option?: OptionInterface;
}

const Option: FunctionComponent<OptionProps> = ({ option = {} }) => (
  <div className={styles.root}>
    {option.icon ? (
      <Icon icon={option.icon} size={20} className={styles.icon} />
    ) : option.reserveIconSpace ? (
      <div className={styles.empty_icon} />
    ) : null}
    <span>{option.label}</span>
  </div>
);

export default Option;
